import { createStaticPropsFetcher } from '@lib/fetch/getStaticProps';
import { getStaticPaths as utilGetStaticPaths } from '@lib/fetch/getStaticPaths';
import Blocks from '@component/Blocks';
import EntryMeta from '@component/EntryMeta';
import PageHeader from '@component/PageHeader';
import RelatedEntries from '@component/RelatedEntries';
import LayoutDefault from '@layout/LayoutDefault';
import type { GetStaticPaths, GetStaticProps, NextPage } from 'next';
import { useView } from '@lib/store';
import { isEntry } from '@lib/features/entries';
import { fmtCategoryNames } from '@lib/utils/format';
import Link from '@components/Link';
import SocialLinks from '@components/SocialLinks';
import { useTranslations } from 'next-intl';

const ProfileView: NextPage = () => {
  const view = useView();
  const t = useTranslations();

  const metaValues = isEntry(view, 'profile')
    ? [
        {
          label: t('profile.discipline'),
          value: fmtCategoryNames(view.profileCategory),
        },
        {
          label: t('profile.website'),
          value: view.websiteUrl && (
            <Link href={view.websiteUrl} target="_blank">
              {new URL(view.websiteUrl).toString()}
            </Link>
          ),
        },
        {
          label: t('profile.socialMedia'),
          value: (
            <SocialLinks
              links={view.socialLinks}
              spacing="3xs"
              cx={{ mT: '3xs' }}
              IconButtonProps={{ size: 'small', color: 'primary' }}
            />
          ),
        },
      ]
    : null;

  return (
    <LayoutDefault
      slots={{
        header: <PageHeader />,
        body: [<Blocks key="blocks" />],
        footer: <RelatedEntries key="relatedEntries" />,
        sidebar: metaValues && <EntryMeta metaValues={metaValues} />,
      }}
    />
  );
};

export const getStaticProps: GetStaticProps = createStaticPropsFetcher('profile');

export const getStaticPaths: GetStaticPaths = async () =>
  await utilGetStaticPaths({ entrySection: 'profile' }, true);

export default ProfileView;
